export const getSessionStorageOrDefault = (key: string, defaultValue: any) => {
    const stored =
        typeof window !== 'undefined' ? sessionStorage.getItem(key) : null;
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);
};
